module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (3).6c5e72f9.jpg";